var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(!_vm.isWidth)?_c('div',{style:({width: '100%', height: '80vh'}),attrs:{"id":"myChart"}}):_vm._e(),(_vm.isWidth)?_c('div',{style:({width: '100%', height: '80vh'}),attrs:{"id":"myChartTwo"}}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }